import type { ReactNode } from "react";

import {
  InfoIcon,
  SealCheckIcon as PhosphorSealCheckIcon,
} from "@phosphor-icons/react";

import { Text } from "@alpacahq/ui/old";

const SealCheckIcon = () => {
  return (
    <PhosphorSealCheckIcon
      size={20}
      className="[&>path:first-child]:fill-yellow-200 [&>path:first-child]:opacity-100"
      weight="duotone"
    />
  );
};

export const FpslBenefits = ({
  eliteRate,
  children,
}: {
  eliteRate: string | null;
  children?: ReactNode;
}) => {
  return (
    <div className="rounded bg-indigo-50 p-4">
      <div className="mb-3 flex items-center gap-2">
        <InfoIcon size={20} className="text-indigo-600" />
        <Text className="font-medium text-gray-900">Program Benefits</Text>
        <a
          href="https://alpaca.markets/support/tag/stock-lending"
          target="_blank"
          className="ml-auto font-medium text-indigo-600 text-xs underline"
          rel="noopener"
        >
          More Info
        </a>
      </div>

      <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-3">
        <SealCheckIcon />
        <div>
          <Text className="mb-1 font-medium text-gray-700 text-sm">
            Earn up to {eliteRate ?? "-"}%<sup>*</sup> of Interest Income
          </Text>
          <Text className="text-gray-700 text-sm">
            Let your portfolio generate extra income automatically.
          </Text>
        </div>

        <SealCheckIcon />
        <div>
          <Text className="mb-1 font-medium text-gray-700 text-sm">
            Fully Automated
          </Text>
          <Text className="text-gray-700 text-sm">
            We spot eligible shares, lend them when there's demand, and back
            every loan with cash collateral.
          </Text>
        </div>

        <SealCheckIcon />
        <div>
          <Text className="mb-1 font-medium text-gray-700 text-sm">
            Stay in Full Control
          </Text>
          <Text className="text-gray-700 text-sm">
            You remain the owner of your shares at all times. Trade, sell, or
            opt out anytime.
          </Text>
        </div>
      </div>
      {children && <div className="mt-3">{children}</div>}
    </div>
  );
};
